import { SESSION_STORAGE_KEYS, SUBMODULE_TYPE } from '@constants/constants';

export const SUBMODULE_QUERY_PARAM = 'submodule';

export interface DeepLinkParam {
  query: string;
  storageKey: string;
  isValid: (value?: string) => boolean;
}

export interface DeepLinkConfig {
  params: DeepLinkParam[];
}
/**
 * Submodules the website can deep-link into, and the params each one accepts.
 * Also acts as the allowlist: a submodule not listed here is ignored.
 */
export const DEEP_LINK_CONFIG: Partial<Record<SUBMODULE_TYPE, DeepLinkConfig>> = {
  [SUBMODULE_TYPE.MARKET_SCAN]: {
    params: [
      {
        query: 'category',
        storageKey: SESSION_STORAGE_KEYS.MARKET_SCANNER_CATEGORY,
        isValid: (value) => Boolean(value?.trim()),
      },
      {
        query: 'genre',
        storageKey: SESSION_STORAGE_KEYS.MARKET_SCANNER_GENRE,
        isValid: (value) => Boolean(value?.trim()),
      },
    ],
  },
};
